import React from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { useAuth } from "../contexts/AuthContext";
import { downloadCsv } from "../lib/csvExport";

/**
 * Bouton "Exporter la sélection" (admin/manager only).
 *
 * Props :
 *   filename  : string (sans extension, sans timestamp)
 *   columns   : Array<{ key?: string, label: string, value?: (row) => any }>
 *   rows      : Array — déjà filtré côté parent
 *   disabled  : bool (forçage externe)
 *   testid    : string
 *   label     : string (optionnel, défaut "Exporter la sélection")
 */
export default function ExportCsvButton({
  filename,
  columns,
  rows,
  disabled = false,
  testid = "export-csv-btn",
  label = "Exporter la sélection",
  className = "",
}) {
  const { user } = useAuth();
  const allowed = user?.role === "admin" || user?.role === "manager";
  if (!allowed) return null;

  const count = Array.isArray(rows) ? rows.length : 0;
  const isDisabled = disabled || count === 0;

  const onClick = () => {
    if (isDisabled) return;
    try {
      downloadCsv({ filename, columns, rows });
      toast.success(`Export CSV téléchargé (${count} ligne${count > 1 ? "s" : ""})`);
    } catch (e) {
      toast.error("Échec de l'export CSV");
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={isDisabled}
      className={`rounded-sm ${className}`}
      data-testid={testid}
      title={isDisabled && count === 0 ? "Aucune ligne à exporter" : label}
    >
      <Download size={13} className="mr-1.5" />
      {label}
      {count > 0 && (
        <span className="ml-1.5 text-[10px] font-mono px-1.5 py-0.5 rounded-sm bg-zinc-100 text-zinc-700 border border-zinc-200">
          {count}
        </span>
      )}
    </Button>
  );
}
